import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import DealService from '../../api/services/DealService';
import Select from 'react-select';
const EditDeal = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_Deal_IMAGE_URL;
  const params = useParams();
  const [error, setError] = useState("")
  const [featureModal, setFeatureModal] = useState(false);
  const [isLoading, setisloading] = useState(true);
  const [feature, setFeature] = useState([]);
  const [is_home_page, setIs_home_page] = useState();
  const [file, setFile] = useState()
  const [smallicon, setSmallIcon] = useState()
  const [fileMobile, setMobileFile] = useState()
  const [fileTablet, setTabletFile] = useState()
  useEffect(() => {
    var id = params.id;
    getFeatureByID(id);
  }, []);

  const options = [
    { value: '1', label: 'True' },
    { value: '0', label: 'False' },

  ]
  const getFeatureByID = async (id) => {
    try {
      let feature = await DealService.show(id).json();
     
      setFeature(feature.data);
      setisloading(false);
      let selecthome = options.filter(function (item) {
        return item.value === feature.data.is_home_page.toString();
      });
      setIs_home_page(selecthome)
      console.log(selecthome)
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
  const onIconChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var smallicon = fileReader.result
      setSmallIcon(smallicon)
    }
  }
  const onFileMobileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var mobileicon = fileReader.result
      setMobileFile(mobileicon)
    }
  }
  const onFileTabletChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var tableticon = fileReader.result
      setTabletFile(tableticon)
    }
  }
  const handlehome = ishome => {
    setIs_home_page(ishome)
  }
  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        title: event.target.title.value,
        "de_title": event.target.de_title.value,
        sub_title: event.target.sub_title.value,
        "de_sub_title": event.target.de_sub_title.value,
        description: event.target.description.value,
        "de_description": event.target.de_description.value,
        button_text: event.target.button_text.value,
        "de_button_text": event.target.de_button_text.value,
        button_link: event.target.button_link.value,
        is_home_page: is_home_page.value ? is_home_page.value : is_home_page[0].value,
        logo: file ? file.split(',')[1] : "",
        feature_image: smallicon ? smallicon.split(',')[1] : "",        
        tablet_image: fileTablet ? fileTablet.split(',')[1] : "",
        mobile_image: fileMobile ? fileMobile.split(',')[1] : ""
      }
      let responseData = await DealService.update(params.id, userData).json()
      if (responseData.status === true) {
        setFeatureModal(true)
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  return (
    <>
      <MainPagetitle mainTitle="Edit Deal" pageTitle={'Edit Deal'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Deal</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          feature.title
                            ? feature.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username"
                        defaultValue={feature.de_title? feature.de_title: ''} 
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Sub Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='sub_title' id="val-username"
                        defaultValue={
                          feature.sub_title
                            ? feature.sub_title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Sub Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_sub_title' id="val-username"
                        defaultValue={feature.de_sub_title? feature.de_sub_title: ''} 
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Description<span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='description' defaultValue={
                        feature.description
                          ? feature.description
                          : ''
                      }></textarea>

                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Description<span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='de_description' 
                        defaultValue={feature.de_description? feature.de_description: ''}
                      ></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Button Text<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='button_text' id="val-username" placeholder="" defaultValue={
                        feature.button_text
                          ? feature.button_text
                          : ''
                      } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Button Text<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_button_text' id="val-username" placeholder="" 
                        defaultValue={feature.de_button_text? feature.de_button_text: ''} 
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Button Link<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='button_link' id="val-username" placeholder=""
                        defaultValue={
                          feature.button_link
                            ? feature.button_link
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Is Homepage<span className="text-danger">*</span></label>

                      <Select
                        options={options}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        value={is_home_page}
                        onChange={handlehome}

                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      {/* {feature.logo ? <img className="img-drop-area" height={100} width={100} name="icon" src={file ? file : imageUrl + feature.logo} alt='' /> : null}
                      <input type="file" className="form-control" name='icon' onChange={onFileChange} accept='.svg' /> */}
                      {feature.logo ? <img className="img-drop-area" height={100} width={100} name="image" src={file ? file : imageUrl + feature.logo} alt='' /> : null}
                      <input type="file" className="form-control" name='image' id="val-number" onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Desktop Image <span className="text-danger">*</span></label>
                      {feature.feature_image ? <img className="img-drop-area" height={100} width={100} name="smallicon" src={smallicon ? smallicon : imageUrl + feature.feature_image} alt='' /> : null}
                      <input type="file" className="form-control" name='smallicon' onChange={onIconChange} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Mobile Image <span className="text-danger">*</span></label>
                      
                      {feature.mobile_image ? <img className="img-drop-area" height={100} width={100} name="mobile_image" src={fileMobile ? fileMobile : imageUrl + feature.mobile_image} alt='' /> : null}
                      <input type="file" className="form-control" name='mobile_image' onChange={onFileMobileChange} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Tablet Image <span className="text-danger">*</span></label>
                      {feature.tablet_image ? <img className="img-drop-area" height={100} width={100} name="tablet_image" src={fileTablet ? fileTablet : imageUrl + feature.tablet_image} alt='' /> : null}
                      <input type="file" className="form-control" name='tablet_image' onChange={onFileTabletChange} />
                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={featureModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setFeatureModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Deal Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to='/admin/deal' variant="danger light" onClick={() =>
            setFeatureModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditDeal;